import { render, staticRenderFns } from "./FormContactCustomer.vue?vue&type=template&id=2b8f6c75&"
import script from "./FormContactCustomer.vue?vue&type=script&lang=ts&"
export * from "./FormContactCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b8f6c75')) {
      api.createRecord('2b8f6c75', component.options)
    } else {
      api.reload('2b8f6c75', component.options)
    }
    module.hot.accept("./FormContactCustomer.vue?vue&type=template&id=2b8f6c75&", function () {
      api.rerender('2b8f6c75', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ContactData/FormContactCustomer.vue"
export default component.exports